import getBevName from './get-bev-name';
import getDisplayType from '../get-display-type';
import getDeviceFeature from '../get-device-feature';
import globals from '../../../../../globals/globals';
var labelHandlers = {
  'UNREAD_MESSAGE': function UNREAD_MESSAGE(label) {
    var unreadCount = globals().customerUnreadMessages;
    var applicationMessages = typeof unreadCount !== 'undefined' ? unreadCount : '';
    return label ? label : applicationMessages;
  }
};
export default function getClassicLink(link) {
  var linkId = link.navigationId || link.label;
  var labelHandler = labelHandlers[linkId];
  var linkName = labelHandler ? labelHandler(link.label) : link.label;
  var displayType = getDisplayType(link);
  return {
    navigationUrl: link.url,
    linkId: linkId,
    linkName: linkName,
    deviceFeature: getDeviceFeature(link),
    displayType: displayType,
    samlNavigation: displayType === 'saml',
    secureSessionUrl: true,
    bevName: getBevName(link),
    anchorTagAttributes: link.dataAttributes || {}
  };
}